import { Box, Image, Stack, Text, createStyles } from '@mantine/core'
import React, { memo } from 'react'
import { useLottie } from 'lottie-react'

export interface ServiceCardProps {
  title?: string
  description?: string
  media?: any
  mediaCustomStyles?: any
}

const useStyles = createStyles((theme, params: any) => {
  return {
    wrapper: {
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.white,
      position: 'relative',
      borderRadius: theme.radius.xl,
      paddingBottom: theme.spacing.lg,
      boxShadow: `inset 0 2px 8px 0px ${theme.colors.gray[4]}`,
      '&:hover': {
        boxShadow: `0 1px 10px 3px ${theme.colors.gray[4]}`,
      },

      // Same size at all breakpoints: fill grid cell and enforce minimum dimensions
      width: '100%',
      minHeight: `calc(${theme.spacing.xl} * 10)`,
      minWidth: 0, // allow grid to constrain width; parent grid gives equal column width

      [`@media (max-width: ${theme.breakpoints.md})`]: {
        marginBottom: theme.spacing.lg,
      },
    },
    iconWrapper: {
      position: 'absolute',
      top: -60,
      right: 0,
      left: 0,
      marginInline: 'auto',
      height: 120,
      width: 120,
      borderRadius: '50%',
      border: `1px solid ${theme.colors.gray[5]}`,
      backgroundColor: 'gray',
      boxShadow: 'inset 20px 20px 60px #b1b1b1, inset -20px -20px 60px #ffffff',

      [`@media (max-width: ${theme.breakpoints.md}px)`]: {
        height: 80,
        width: 80,
      },
    },
    contentWrapper: {
      marginTop: 60,

      [`@media (max-width: ${theme.breakpoints.md}px)`]: {
        marginTop: 30,
      },
    },
    titleStyle: {
      fontSize: 22,
      fontWeight: 600,
      textAlign: 'center',
      color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.dark[5],
    },
    imageStyle: {
      // height: 100,
      // padding: 10,
      ...params.mediaCustomStyles,
    },
  }
})

export const ServiceCard: React.FC<ServiceCardProps> = memo(props => {
  const { title, description, media, mediaCustomStyles } = props
  const { classes } = useStyles({ mediaCustomStyles })

  const { View } = useLottie({
    animationData: media,
    loop: true,
    autoplay: true,
  })

  return (
    <Box className={classes.wrapper}>
      <Stack className={classes.contentWrapper} w={'100%'} p={'md'}>
        <Text align="left" className={classes.titleStyle}>
          {title}
        </Text>
        <Text align="center" mt={'sm'}>
          {description}
        </Text>
      </Stack>
      <Box className={classes.iconWrapper}>
        {typeof media === 'string' ? (
          <Image radius={'lg'} src={media} alt={title ?? 'media'} className={classes.imageStyle} />
        ) : (
          <Box className={classes.imageStyle}>{View}</Box>
        )}
      </Box>
    </Box>
  )
})
